import { TEMPLATE_GALLERY } from '@confluence/named-routes/entry-points/routes.ts';

const TEMPLATE_GALLERY_TAB_BLOCK = 'block';

export const getSnippetShareUrl = (snippetId: string, shareId?: string): string => {
	const query: Record<string, string> = { tab: TEMPLATE_GALLERY_TAB_BLOCK, snippetId };
	if (shareId) {
		query.shareId = shareId;
	}
	return TEMPLATE_GALLERY.toUrl({}, { query });
};
